<div
  *ngIf="colVm?.columnType === Types.SectionColumnProductInfoType.Effects"
  appScaleDownText
  [scaleEnabled]="!(menu | isPrintMenu)"
  [style.color]="
    ignoreUserSetTextColorAndAutoToLightOrDarkTextColor
      ? (section | textColorBasedOnSectionHeaderBackgroundColor)
      : (menu | method: 'getSectionHeaderTextColor' : section)
  "
  class="section-header-general section-header-effects">
  {{ menu | method: 'getTypeColumnTitle' : colVm }}
</div>
